import React from "react";

import {pluralize, priceFormat} from "@pg-mono/string-utils";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {getParkingPlacesType} from "../constants/ParkingPlacesType";

interface IOfferDetailGeneratedDescriptionParkingPlaces {
    parking_places: IParkingPlace[];
    investor: string | null;
    vendor: {
        type: VendorType;
        name: string;
    };
    offerName: string;
}

export const renderParkingPlacesGenericText = (isParkingPlaces: boolean, offerInvestmentName: string, renderParkingPlaces?: React.ReactNode) => {
    if (!isParkingPlaces) {
        return <p>Dla przyszłych mieszkańców {offerInvestmentName} deweloper nie przewidział miejsc postojowych.</p>;
    }
    return (
        <p>
            {`Dla przyszłych mieszkańców ${offerInvestmentName} deweloper przewidział${renderParkingPlaces ? " " : ":"}`}
            {renderParkingPlaces}
        </p>
    );
};

const parkingPlacesQuantity = pluralize(["miejsce", "miejsca", "miejsc"]);

export const OfferDetailGeneratedDescriptionParkingPlaces = (props: IOfferDetailGeneratedDescriptionParkingPlaces) => {
    const {parking_places, offerName} = props;

    const isParkingPlaces = !!parking_places?.length;

    if (!isParkingPlaces) {
        renderParkingPlacesGenericText(isParkingPlaces, offerName);
    }

    const renderParkingPlaces = (): React.ReactNode => {
        return parking_places.map((parkingPlace: IParkingPlace) => {
            return (
                <li key={parkingPlace.id} className="fs16 mb-sm">
                    {`${getParkingPlacesType(parkingPlace.type).toLowerCase()} ${
                        parkingPlace.quantity ? `(${parkingPlace.quantity} ${parkingPlacesQuantity(parkingPlace.quantity)})` : ""
                    } ${typeof parkingPlace.price === "number" && Number.isFinite(parkingPlace.price) ? ` w cenie ${priceFormat(parkingPlace.price)}` : ""}`}
                </li>
            );
        });
    };

    return (
        <>
            {renderParkingPlacesGenericText(isParkingPlaces, offerName)}

            <ul>{renderParkingPlaces()}</ul>
        </>
    );
};
import React from "react";

import {pluralize, priceFormat} from "@pg-mono/string-utils";

import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {getParkingPlacesType} from "../constants/ParkingPlacesType";

interface IOfferDetailGeneratedDescriptionParkingPlaces {
    parking_places: IParkingPlace[];
    investor: string | null;
    vendor: {
        type: VendorType;
        name: string;
    };
    offerName: string;
}

export const renderParkingPlacesGenericText = (isParkingPlaces: boolean, offerInvestmentName: string, renderParkingPlaces?: React.ReactNode) => {
    if (!isParkingPlaces) {
        return <p>Dla przyszłych mieszkańców {offerInvestmentName} deweloper nie przewidział miejsc postojowych.</p>;
    }
    return (
        <p>
            {`Dla przyszłych mieszkańców ${offerInvestmentName} deweloper przewidział${renderParkingPlaces ? " " : ":"}`}
            {renderParkingPlaces}
        </p>
    );
};

const parkingPlacesQuantity = pluralize(["miejsce", "miejsca", "miejsc"]);

export const OfferDetailGeneratedDescriptionParkingPlaces = (props: IOfferDetailGeneratedDescriptionParkingPlaces) => {
    const {parking_places, offerName} = props;

    const isParkingPlaces = !!parking_places?.length;

    if (!isParkingPlaces) {
        renderParkingPlacesGenericText(isParkingPlaces, offerName);
    }

    const renderParkingPlaces = (): React.ReactNode => {
        return parking_places.map((parkingPlace: IParkingPlace) => {
            return (
                <li key={parkingPlace.id} className="fs16 mb-sm">
                    {`${getParkingPlacesType(parkingPlace.type).toLowerCase()} ${
                        parkingPlace.quantity ? `(${parkingPlace.quantity} ${parkingPlacesQuantity(parkingPlace.quantity)})` : ""
                    } ${typeof parkingPlace.price === "number" && Number.isFinite(parkingPlace.price) ? ` w cenie ${priceFormat(parkingPlace.price)}` : ""}`}
                </li>
            );
        });
    };

    return (
        <>
            {renderParkingPlacesGenericText(isParkingPlaces, offerName)}

            <ul>{renderParkingPlaces()}</ul>
        </>
    );
};
